import { chessFieldsNames } from '../../forms/ChessForm/constants/chessFieldsNames';

export const getExceptionEntranceData = (keys, values) => {
  const map = new Map();

  keys.forEach((currentKey) => {
    const { differentFloorEntrance, differentFloorNumOf, differentFlatNumOf } =
      chessFieldsNames;

    const entranceNum = values[`${differentFloorEntrance}-${currentKey}`];
    const floorCount = values[`${differentFloorNumOf}-${currentKey}`];
    const flatCount = values[`${differentFlatNumOf}-${currentKey}`];

    if (entranceNum && (floorCount || flatCount)) {
      map.set(Number(entranceNum), {
        floorCount: floorCount ? Number(floorCount) : undefined,
        flatCount: flatCount ? Number(flatCount) : undefined,
      });
    }
  });

  return map;
};

export const getPorchs = (values) => {
  const { numberOfFlats, numberOfEntrances, numberOfFloors } = values;

  const exceptionEntranceDataMap = getExceptionEntranceData(
    values.differentFloorKeys,
    values
  );

  const flatCount = Number(numberOfFlats);
  const entranceCount = Number(numberOfEntrances);
  const floorCount = Number(numberOfFloors);

  let porchs = [];

  for (let i = 1; i <= entranceCount; i++) {
    const exceptionEntranceData = exceptionEntranceDataMap.get(i) || {};
    const prevPorch = porchs[porchs.length - 1];

    const { floorCount: exceptionFloorCount, flatCount: exceptionFlatCount } =
      exceptionEntranceData;

    const equalExceptionFloors =
      exceptionFloorCount !== undefined &&
      prevPorch?.floors === exceptionFloorCount;

    const equalFloors =
      exceptionFloorCount === undefined && prevPorch?.floors === floorCount;

    const equalExceptionFlats =
      exceptionFlatCount !== undefined &&
      prevPorch?.flatsPerFloor === exceptionFlatCount;

    const equalFlats =
      exceptionFlatCount === undefined &&
      prevPorch?.flatsPerFloor === flatCount;

    const prevPorchNeedsChanged =
      prevPorch &&
      (equalExceptionFloors || equalFloors) &&
      (equalExceptionFlats || equalFlats);

    if (prevPorchNeedsChanged) {
      prevPorch.toPorch = i;
    } else {
      const porch = {
        fromPorch: i,
        toPorch: i,
        flatsPerFloor: exceptionFlatCount ?? flatCount,
        floors: exceptionFloorCount ?? floorCount,
      };

      porchs.push(porch);
    }
  }

  return porchs;
};

export const getPreviewData = (values) => {
  const {
    differentFloorKeys,
    numberOfEntrances,
    numberOfFloors,
    numberOfFlats,
  } = values;

  let porchs = [];

  const exceptionEntranceDataMap = getExceptionEntranceData(
    differentFloorKeys,
    values
  );

  const entranceCount = Number(numberOfEntrances);

  let flatNum = 1;

  for (let e = 1; e <= entranceCount; e++) {
    const { floorCount: exceptionFloorCount, flatCount: exceptionFlatCount } =
      exceptionEntranceDataMap.get(e) || {};

    const flats = [];

    const floorCount = exceptionFloorCount ?? numberOfFloors;

    const flatCount = exceptionFlatCount
      ? exceptionFlatCount * floorCount
      : numberOfFlats * floorCount;

    const numOfFlats = exceptionFlatCount ?? numberOfFlats;

    for (let f = 1; f <= flatCount; f++) {
      const floor = Math.ceil(f / numOfFlats);
      const flat = {
        floor,
        flat: `${flatNum}`,
        size: 1,
        cells: [
          {
            porch: `${e}`,
            row: `${floor}`,
            col: `${f - numOfFlats * (`${floor}` - 1)}`,
          },
        ],
      };

      flats.push(flat);
      flatNum += 1;
    }

    const porch = {
      name: `${e}-й подъезд`,
      flats,
    };

    porchs.push(porch);
  }

  return { porchs, flatCount: flatNum - 1 };
};

export const getFlatCountState = (values, currentHouse) => {
  const { numberOfEntrances, numberOfFloors, numberOfFlats } = values;

  if (numberOfEntrances && numberOfFloors && numberOfFlats) {
    const { flatCount } = getPreviewData(values);

    const isFlatCountError =
      currentHouse?.flatCount > 0 && flatCount !== currentHouse?.flatCount;

    if (isFlatCountError) {
      return { error: true, flatCount };
    } else {
      return { error: false, flatCount: undefined };
    }
  }
};
